import { render } from "./FreeRoomsList.vue?vue&type=template&id=25b2cb54&scoped=true"
import script from "./FreeRoomsList.vue?vue&type=script&lang=js"
export * from "./FreeRoomsList.vue?vue&type=script&lang=js"

import "./FreeRoomsList.vue?vue&type=style&index=0&id=25b2cb54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b2cb54"]])

export default __exports__